const submodules = {
  apiPath: 'submodules/',
  buttonNew: 'Стварыць модуль',
  tableConfig: {
    name: {
      key: 'name',
      title: 'Назва',
      sortable: true,
    },
    updatedAt: {
      key: 'updatedAt',
      title: 'Абноўлена',
      sortable: true,
      format: 'date',
    },
    status: {
      key: 'status',
      title: 'Статус',
      sortable: true,
    },
  },
  tableConfigDND: {
    name: {
      key: 'name',
      title: 'Назва',
      sortable: true,
      class: 'main',
    },
    status: {
      key: 'status',
      title: 'Статус',
      sortable: true,
      class: 'status',
    },
  },
};

export default submodules;
